
interface BackToTopProps {
  show: boolean;
  onClick: () => void;
}

export default function BackToTop({ show, onClick }: BackToTopProps) {
  if (!show) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-8 right-8 bg-teal-600 hover:bg-teal-700 text-white w-12 h-12 rounded-full shadow-lg transition-all duration-300 cursor-pointer z-40"
      aria-label="Back to top"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}
